import { render } from "./FeedbackDetails.vue?vue&type=template&id=817ba37e&scoped=true"
import script from "./FeedbackDetails.vue?vue&type=script&lang=js"
export * from "./FeedbackDetails.vue?vue&type=script&lang=js"

import "./FeedbackDetails.vue?vue&type=style&index=0&id=817ba37e&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-817ba37e"]])

export default __exports__